// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17w9r","content":"styles_content__tB4Y3"};